import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ValidationPatterns } from '../validation-patterns';
import { IValidationHandler, TValidatorError } from '../../model';

export function mobilePhoneValidator(args: IValidationHandler): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value, invalid } = control;

    if (invalid) return null;

    if (!value) return null;

    const matchMobilePhone = value.match(ValidationPatterns.mobilePhone);

    if (!matchMobilePhone?.length) {
      const vldResponse: TValidatorError = { mobilePhone: value };
      return vldResponse;
    }

    return null;
  };
}
